import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { AttributeComponent } from '../../interfaces/attribute.component';
import { AttributeDefinition } from '../../models/attribute-definition';
import { AttributeControlService } from '../../attribute-control-service';
import { DatepickerUtilsService } from 'src/app/services/ui/datepicker-utils.service';
import { NgxMatDatetimePicker } from '@angular-material-components/datetime-picker';

@Component({
  selector: 'app-date',
  templateUrl: './date.component.html',
  styleUrls: ['./date.component.scss']
})
export class DateComponent implements OnInit, AttributeComponent {
  @Input() formGroup: FormGroup;
  @Input() attributeDefinition: AttributeDefinition;

  @Output() onRemove = new EventEmitter<number>();

  @ViewChild('datePicker') datePicker: NgxMatDatetimePicker<Date>;
  openAt: Date | null = null;

  constructor(
    public _attributeControlService: AttributeControlService<Date | null>,
    public _datePickerUtilService: DatepickerUtilsService
  ) { }

  ngOnInit(): void {
    const initial = this._datePickerUtilService.getDate(this.attributeDefinition.value);
    this._attributeControlService.addFormControl(
      this.attributeDefinition.formControlName,
      this.attributeDefinition.isRequired,
      initial,
      this.formGroup
    );
  }

  get control(): FormControl {
    return this.formGroup.get(this.attributeDefinition.formControlName) as FormControl;
  }

  get label(): string {
    return (this.attributeDefinition?.name || '').replace(/\s*[:*]+$/, '').trim();
  }

  getErrorMessage(): string {
    if (!this.control) return '';
    if (this.control.hasError('required')) return `${this.label} is required.`;
    if (this.control.hasError('matDatepickerParse') || this.control.hasError('ngxMatDatetimePickerParse')) {
      return `Invalid ${this.label.toLowerCase()}.`;
    }
    return '';
  }

  onOpen(): void {
    this.openAt = this.control?.value ? new Date(this.control.value) : new Date();
    this.datePicker?.select(this.openAt);
  }

  value(): string | null {
    const val: Date | null = this.control.value;
    this.attributeDefinition.value = val;
    return val ? this._datePickerUtilService.getDateString(val, false) : null;
  }

  clear(ev?: MouseEvent): void {
    ev?.stopPropagation();
    this.control.setValue(null, { emitEvent: true });
    this.control.markAsDirty();
    this.control.markAsTouched();
    this.attributeDefinition.value = null;
  }

  ngOnDestroy(): void {
    this._attributeControlService.removeControl(this.attributeDefinition.formControlName, this.formGroup);
  }
}
